"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.1 25.5",
    width: "21.1",
    height: "25.5"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "2.8",
    y: "1.8",
    fill: "#9ECE06",
    width: "17.7",
    height: "12.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M21.1,14.8H2.3V1.3h18.7V14.8z M3.3,13.8h16.7V2.3H3.3V13.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M0.8,25.5c-0.4,0-0.8-0.3-0.8-0.8v-24C0,0.3,0.3,0,0.8,0s0.8,0.3,0.8,0.8v24C1.5,25.2,1.2,25.5,0.8,25.5z"
  }));
};

exports["default"] = _default;